import { principles } from "@/mocks/civicData";

export default function Principles() {
  return (
    <section
      id="principles"
      className="scroll-mt-24 bg-accent-50 py-16 md:py-24"
    >
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid items-center gap-12 lg:grid-cols-2">
          <div className="relative order-2 lg:order-1">
            <img
              src="https://readdy.ai/api/search-image?query=community%20residents%20chatting%20warmly%20with%20each%20other%20in%20a%20courtyard%20under%20a%20tree%2C%20morning%20soft%20sunlight%2C%20neighbors%20helping%20and%20caring%20atmosphere%2C%20warm%20amber%20and%20soft%20green%20tones%2C%20editorial%20documentary%20photography%2C%20cozy%20and%20trustworthy%20civic%20mood&width=1200&height=900&seq=principle-cy-2026&orientation=landscape"
              alt="社区居民在庭院中友好交流，展现邻里守望互助的氛围"
              className="w-full rounded-3xl object-cover"
            />
          </div>

          <div className="order-1 lg:order-2">
            <p className="inline-flex items-center gap-2 text-sm font-medium text-primary-600">
              <span className="h-px w-8 bg-primary-400"></span>
              参与原则
            </p>
            <h2 className="mt-4 font-heading text-3xl font-bold text-foreground-950 md:text-4xl">
              理性参与，是善意的表达方式
            </h2>
            <p className="mt-5 text-base leading-8 text-foreground-600">
              维护社会秩序、守护共同家园，靠的是每一个人负责任的态度。坚持以下四条原则，让善意落在对的地方。
            </p>

            <div className="mt-8 space-y-5">
              {principles.map((p) => (
                <div key={p.title} className="flex gap-4">
                  <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-primary-100 text-xl text-primary-600">
                    <i className={p.icon}></i>
                  </span>
                  <div>
                    <h3 className="font-heading text-base font-bold text-foreground-900">
                      {p.title}
                    </h3>
                    <p className="mt-1 text-sm leading-7 text-foreground-600">{p.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}